import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { useQuery } from 'urql';
import { CollectionComponent } from '../collection/CollectionComponent';
import { getCollection, getCollectionSansSwatches } from './queries';
import css from './Collection.module.scss';
import CollectionLoading from '../../components/CollectionLoading';
import CollectionSet from './CollectionSet';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CollectionLoader = function CollectionLoader(_ref) {
  var displaySwatches = _ref.displaySwatches,
      shopifyId = _ref.shopifyId;

  var _useQuery = useQuery({
    query: displaySwatches ? getCollection : getCollectionSansSwatches,
    variables: {
      shopifyId: shopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx(CollectionLoading, {});
  }

  var collection = data.collection;
  var productSets = collection.productSets,
      properties = collection.properties;
  var bottomComponent = properties.bottomComponent,
      footerComponent = properties.footerComponent,
      gridDisplayEditorial = properties.gridDisplayEditorial,
      gridDisplaySwatches = properties.gridDisplaySwatches; // If we are not requesting the colorways, set the faceout color

  if (!gridDisplaySwatches) {
    productSets.forEach(function (productSet) {
      productSet.products.edges.forEach(function (_ref2) {
        var _ref2$node = _ref2.node,
            component = _ref2$node.component,
            product = _ref2$node.product,
            faceout = _ref2$node.faceout;

        if (component) {
          return;
        }
        /* eslint-disable no-param-reassign */


        product.colorways = {
          edges: [{
            node: faceout
          }]
        };
      });
    });
  }

  var compareAds = [];
  productSets.forEach(function (productSet) {
    productSet.products.edges.forEach(function (_ref3) {
      var _node$product, _node$component$admin;

      var node = _ref3.node;
      (_node$product = node.product) === null || _node$product === void 0 ? void 0 : _node$product.colorways.edges.forEach(function (_ref4) {
        var _node$sizesAvailable;

        var node = _ref4.node;
        (_node$sizesAvailable = node.sizesAvailable) === null || _node$sizesAvailable === void 0 ? void 0 : _node$sizesAvailable.forEach(function (size) {
          size.sizesSplit = size.size.replace(/\s/g, '').split(/[/-]/).reduce(function (acc, curr) {
            return acc[curr] = true, acc;
          }, {});
        });
      });

      if (node.component !== null && (_node$component$admin = node.component.adminTitle) !== null && _node$component$admin !== void 0 && _node$component$admin.includes('#compare')) {
        compareAds.push(node.component);
      }
    });
  });

  if (gridDisplayEditorial) {
    // Loop through all of the images and see if there is an editorial match. If there is, swap the images
    productSets.forEach(function (_ref5) {
      var edges = _ref5.products.edges;
      return edges.forEach(function (_ref6) {
        var product = _ref6.node.product;
        product === null || product === void 0 ? void 0 : product.colorways.edges.forEach(function (_ref7) {
          var node = _ref7.node;

          if (node.assets.edges.length > 1 && node.assets.edges[1].node.isEditorial) {
            node.image = node.assets.edges[1].node.image;
          }
        });
      });
    });
  }

  var collectionProps = {
    collection: collection,
    productSets: productSets,
    compareAds: compareAds
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CollectionSet, _objectSpread(_objectSpread({}, collectionProps), {}, {
      noMargin: true
    })), bottomComponent && /*#__PURE__*/_jsx("div", {
      className: css.component,
      children: /*#__PURE__*/_jsx(CollectionComponent, {
        component: bottomComponent,
        collectionId: collection.id
      })
    }), footerComponent && /*#__PURE__*/_jsx("div", {
      className: css.component,
      children: /*#__PURE__*/_jsx(CollectionComponent, {
        component: footerComponent,
        collectionId: collection.id
      })
    })]
  });
};

CollectionLoader.defaultProps = {
  shopifyId: ''
};
CollectionLoader.propTypes = {
  displaySwatches: PropTypes.bool.isRequired,
  shopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default CollectionLoader;